import { combineReducers } from 'redux';
import globalReducer from './reducers/global';
import CertificateInputPCReducer from '../module/PC/CertificateInput/reducer';
import CertificateInputH5Reducer from '../module/H5/CertificateInput/reducer';
import NameInputReducer from '../module/common/NameInput/reducer';
import PhoneInputReducer from '../module/common/PhoneInput/reducer';
import LoginAddressSelectReducer from '../module/common/LoginAddressSelect/reducer';
import UsedPasswordReducer from '../module/common/UsedPasswordInput/reducers';
import RegistrationTimeReducer from '../module/common/RegistrationTimeSelect/reducer';
import RegistrationAddressReducer from '../module/common/RegistrationAddressSelect/reducer';
import UsedPhoneReducer from '../module/common/UsedPhoneInput/reducer';
import HistoricalMailSubjectReducer from '../module/common/HistoricalMailSubjectInput/reducer';
import MailPaymentOrderReducer from '../module/common/MailPaymentOrderInput/reducer';
import GlobalModalBoxReducer from '../module/common/GlobalModalBox/reducer';
import CertificatePhotoInputReducer from '../module/common/CertificatePhotoInput/reducer';
import VerifyCodeReducer from '../module/common/VerifyCodeInput/reducer';
import IDNumberInputReducer from '../module/common/IDNumberInput/reducer';
import BankCardNumberInputReducer from '../module/common/BankCardNumberInput/reducer';
import BankPhoneNumberInputReducer from '../module/common/BankPhoneNumberInput/reducer';
import IDPhotoInputReducer from '../module/common/IDPhotoInput/reducer';
import HistoricalContactPersonReducer from '../module/common/HistoricalContactPersonInput/reducer';
import PhoneNumberCompletionReducer from '../module/common/PhoneNumberCompletionInput/reducer';
import GlobalToastReducer from '../module/common/GlobalToast/reducer';
import ContactEmailInputReducer from '../module/common/ContactEmailInput/reducer';
import SafePhoneVerifyReducer from '../module/common/MethodCard/reducer';

const isH5 = process.env.MAIL_APP_PLATFORM === 'h5';

const rootReducer = combineReducers({
    global: globalReducer,
    CertificateInput: isH5 ? CertificateInputH5Reducer : CertificateInputPCReducer,
    NameInput: NameInputReducer,
    PhoneInput: PhoneInputReducer,
    LoginAddressSelect: LoginAddressSelectReducer,
    UsedPasswordInput: UsedPasswordReducer,
    RegistrationTime: RegistrationTimeReducer,
    RegistrationAddress: RegistrationAddressReducer,
    UsedPhoneInput: UsedPhoneReducer,
    HistoricalMailSubject: HistoricalMailSubjectReducer,
    MailPaymentOrder: MailPaymentOrderReducer,
    GlobalModalBox: GlobalModalBoxReducer,
    GlobalToast: GlobalToastReducer,
    CertificatePhotoInput: CertificatePhotoInputReducer,
    VerifyCode: VerifyCodeReducer,
    IDNumberInput: IDNumberInputReducer,
    BankCardNumberInput: BankCardNumberInputReducer,
    BankPhoneNumberInput: BankPhoneNumberInputReducer,
    IDPhotoInput: IDPhotoInputReducer,
    HistoricalContactPerson: HistoricalContactPersonReducer,
    PhoneNumberCompletion: PhoneNumberCompletionReducer,
    ContactEmailInput: ContactEmailInputReducer,
    SafePhoneVerify: SafePhoneVerifyReducer,
});

export default rootReducer;
